/* global axios */
import ApiClient from '../ApiClient';

// Prime Insight — high-risk AI actions awaiting human approval for a conversation.
// GET  /api/v1/accounts/:account_id/conversations/:conversation_id/metrica_pending_approvals
// POST .../metrica_pending_approvals/:id/approve
// POST .../metrica_pending_approvals/:id/reject
class MetricaPendingApprovalsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  list(conversationId) {
    return axios.get(`${this.url}/${conversationId}/metrica_pending_approvals`);
  }

  approve(conversationId, id) {
    return axios.post(
      `${this.url}/${conversationId}/metrica_pending_approvals/${id}/approve`
    );
  }

  reject(conversationId, id) {
    return axios.post(
      `${this.url}/${conversationId}/metrica_pending_approvals/${id}/reject`
    );
  }
}

export default new MetricaPendingApprovalsAPI();
